import { Button, Spinner } from 'react-bootstrap';

const SkillsMatrixErrorTab = ({ retry, loading }) => {
  return (
    <div className="p-3 bg-white skills-matrix">
      <div className="pt-2">There was an error loading the user data, please try again later.</div>

      <div className="pt-4 pb-4">
        <Button variant="primary" onClick={retry} disabled={loading}>
          {loading ? <Spinner animation="border" size="sm" /> : 'Retry'}
        </Button>
      </div>
    </div>
  );
};

export default SkillsMatrixErrorTab;
